import React from "react";
import avataria from "../assets/avataria.png";
import wowImage2 from "../assets/Wow2.png";
import CallToAction from "./CallToAction";
import plus from "../assets/plus.png"
function Pricing() {
    return (
        <div className="pricing">
            <div className="container py-3">
                <h2 className="section-title">Precio</h2>
                <div className="row" style={{placeContent:"space-evenly"}}>
                    <div className="plan col-md-3  mb-4 d-flex flex-column justify-content-between">
                        <h3 className="plan-tittle">Creacion Avatatar</h3>
                        <img src={avataria} alt="wow1" style={{ width: "30vh", alignSelf: "center" }} />
                        <p>Representación digital de una persona con voz y una base de conocimiento de tu negocio.
                            Cobro una sola vez</p>
                    
                    </div>
                    <div className="col-md-2 d-flex align-items-center justify-content-center">
                        <img
                            src={plus}
                            alt="plus"
                            className="img-fluid"
                            style={{ width: "100%", maxWidth: "120px", height: "auto" }}
                        />
                    </div>
                    <div className="plan col-md-3 mb-4 d-flex flex-column justify-content-between">
                        <h3 className="plan-tittle">Licencia Mensual</h3>
                        <ul style={{ listStyle: "none", textAlign: "left" }}>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Soporte.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Uso Web.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Multi-idioma.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Representación Digital.</li>
                        </ul>
                        <a className="plan-price mt-auto">Cotiza tu plan</a>
                    </div>
                    <div className="plan col-md-3  mb-4 d-flex flex-column justify-content-between">
                        <h3 className="plan-tittle">Licencia Anual</h3>
                        <ul style={{ listStyle: "none", textAlign: "left" }}>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Soporte.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Uso Web.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Multi-idioma.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Representación Digital.</li>
                            <li><span style={{ color: "#35E865", marginRight: "8px" }}>✔</span>Cambio de Base de Conocimiento.</li>
                        </ul>
                        <a className="plan-price mt-auto">Cotiza tu plan</a>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default Pricing;

